import { Button, Dialog, DialogActions, Stack, Typography } from "@mui/material";
import { GlobalState } from "context/GlobalContext";
import { inputTypes, arrType, selectOptionsKeyName, datatypes } from "data/globalData";
import { useEffect, useMemo, useState } from "react";
import RenderInputField from "components/PimDashboard/CommonComponents/RenderInputField/RenderInputField";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import FileSaver from "file-saver";
import axios from "axios";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";

const DataExportModal = ({ modal, handleCloseModal, filterColumnVal, exportTypeOptions = [] }) => {
	const { snackBar, setSnackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();

	const exportTypeColumn = useMemo(
		() => ({
			name: "File Type",
			key: "export_type",
			input_type: inputTypes.SELECT.key,
			data_type: datatypes.STRING.key,
			constraints: { NOTNULL: true, DISPLAY: true },
			[selectOptionsKeyName]: {
				type: arrType,
				list: exportTypeOptions.map(({ key, name }) => ({ key, name })),
			},
		}),
		[exportTypeOptions],
	);

	const [fileTypeState, setFileTypeState] = useState({
		export_type: exportTypeOptions?.[0]?.key,
	});

	useEffect(() => {
		if (modal && exportTypeOptions?.length) {
			setFileTypeState({ export_type: exportTypeOptions[0].key });
		}
	}, [modal, exportTypeOptions]);

	const handleDownloadClick = async () => {
		const selectedOption = exportTypeOptions.find((row) => row.key === fileTypeState.export_type);
		if (!selectedOption) return;

		try {
			const axiosInstance = selectedOption.usePythonApi === true ? pythonVmInstance : axios;
			setLoadingOpen(true);
			await axiosInstance({
				url: selectedOption.apiUrl,
				method: "POST",
				responseType: "blob",
				data: { filter: filterColumnVal },
			}).then((res) => {
				const url = URL.createObjectURL(res.data);
				FileSaver.saveAs(url, `${selectedOption.fileName}_${new Date().toISOString()}.xlsx`);
				setLoadingOpen(false);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "File Downloaded Successfully",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				handleCloseModal();
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrorMessage(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};

	return (
		<Dialog fullWidth maxWidth="sm" open={modal} onClose={handleCloseModal} scroll="body">
			<Stack width="100%" p={2} boxSizing="border-box" spacing={1}>
				<Typography variant="h6">Export Data</Typography>

				<RenderInputField
					column={exportTypeColumn}
					data={fileTypeState}
					setData={setFileTypeState}
					selectOptObjName={selectOptionsKeyName}
					width="100%"
				/>
			</Stack>
			<DialogActions>
				<Button variant="outlined" onClick={handleCloseModal}>
					Cancel
				</Button>
				<Button autoFocus variant="contained" sx={{ mr: 1 }} onClick={handleDownloadClick}>
					Download
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default DataExportModal;
